var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _path6, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYariga(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141,
    zoomAndPan: "magnify",
    viewBox: "0 0 105.75 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "a9b7e373e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.476562 1.976562 L 36.914062 1.976562 L 36.914062 18 L 3.476562 18 Z M 3.476562 1.976562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d04e4b758a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30 1.976562 L 35 1.976562 L 35 7 L 30 7 Z M 30 1.976562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "167ffa82ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1.976562 L 11 1.976562 L 11 7 L 5 7 Z M 5 1.976562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a91f16d95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 7 L 35 7 L 35 27.441406 L 12 27.441406 Z M 12 7 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a9b7e373e8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M 10.105469 9.230469 L 20.179688 1.976562 L 36.898438 14.03125 L 36.898438 17.761719 L 20.179688 5.726562 L 10.105469 12.980469 Z M 3.457031 14.03125 L 5.566406 12.507812 L 5.566406 16.25 L 3.457031 17.761719 Z M 3.457031 14.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d04e4b758a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M 34.773438 4.257812 C 34.773438 3.007812 33.769531 1.976562 32.53125 1.976562 C 31.296875 1.976562 30.273438 3.007812 30.273438 4.257812 C 30.273438 5.503906 31.296875 6.515625 32.53125 6.515625 C 33.769531 6.523438 34.773438 5.511719 34.773438 4.257812 Z M 34.773438 4.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M 10.167969 14.09375 L 20.179688 8.445312 L 30.191406 14.09375 L 20.179688 6.972656 Z M 10.167969 14.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 17.484375 13.992188 L 19.90625 13.992188 L 19.90625 16.433594 L 17.484375 16.433594 Z M 17.484375 13.992188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 20.453125 13.992188 L 22.875 13.992188 L 22.875 16.433594 L 20.453125 16.433594 Z M 20.453125 13.992188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 17.484375 16.972656 L 19.90625 16.972656 L 19.90625 19.386719 L 17.484375 19.386719 Z M 17.484375 16.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 20.453125 16.972656 L 22.875 16.972656 L 22.875 19.386719 L 20.453125 19.386719 Z M 20.453125 16.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#167ffa82ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 10.085938 4.257812 C 10.085938 3.007812 9.082031 1.976562 7.824219 1.976562 C 6.589844 1.976562 5.585938 3.007812 5.585938 4.257812 C 5.585938 5.503906 6.589844 6.515625 7.824219 6.515625 C 9.082031 6.523438 10.085938 5.511719 10.085938 4.257812 Z M 10.085938 4.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 20.179688 24.386719 C 17.210938 24.386719 14.492188 23.160156 12.527344 21.179688 C 10.5625 19.214844 9.34375 16.480469 9.34375 13.484375 C 9.34375 10.351562 9.34375 12.433594 9.34375 9.300781 L 9.34375 8.902344 C 9.34375 8.066406 8.675781 7.390625 7.84375 7.390625 L 7.824219 7.390625 C 6.996094 7.390625 6.3125 8.066406 6.3125 8.902344 L 6.3125 9.300781 C 6.3125 12.3125 6.3125 10.09375 6.3125 13.109375 L 6.3125 13.484375 C 6.3125 17.316406 7.886719 20.820312 10.386719 23.34375 C 10.820312 23.78125 11.269531 24.179688 11.765625 24.550781 L 12.355469 24.671875 C 15.738281 25.363281 19.515625 25.507812 22.78125 24.273438 C 23.234375 24.109375 23.785156 23.855469 24.3125 23.558594 C 23.027344 24.085938 21.636719 24.386719 20.179688 24.386719 Z M 20.179688 24.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a91f16d95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M 26.117188 22.582031 C 26.117188 22.582031 22.125 26.941406 12.308594 24.960938 C 14.527344 26.523438 17.261719 27.441406 20.171875 27.441406 C 23.992188 27.441406 27.449219 25.878906 29.972656 23.335938 C 32.472656 20.8125 34.042969 17.308594 34.042969 13.480469 L 34.042969 13.101562 C 34.042969 10.089844 34.042969 12.304688 34.042969 9.292969 L 34.042969 8.894531 C 34.042969 8.058594 33.355469 7.386719 32.546875 7.386719 L 32.507812 7.386719 C 31.675781 7.386719 31.007812 8.058594 31.007812 8.894531 L 31.007812 9.292969 C 31.007812 12.425781 31.007812 10.34375 31.007812 13.480469 C 31.007812 16.472656 29.789062 19.210938 27.824219 21.171875 C 27.300781 21.703125 26.726562 22.183594 26.117188 22.582031 Z M 26.117188 22.582031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#141414",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.964734, 20.34611)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#141414",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.943714, 20.34611)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.027344 -7.847656 L 2.082031 -14.273438 L -0.300781 -14.273438 L 5.003906 -5.707031 L 5.003906 0 L 7.046875 0 L 7.046875 -5.707031 L 12.414062 -14.273438 L 10.011719 -14.273438 Z M 6.027344 -7.847656 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#141414",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.014716, 20.34611)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.488281 -1.421875 L 9.488281 0 L 11.351562 0 L 11.351562 -10.933594 L 9.390625 -10.933594 L 9.390625 -4.945312 C 9.390625 -3.042969 8.269531 -1.582031 6.207031 -1.582031 C 3.84375 -1.582031 3.324219 -2.984375 3.324219 -5.003906 L 3.324219 -10.933594 L 1.363281 -10.933594 L 1.363281 -5.003906 C 1.363281 -1.902344 2.78125 0.160156 6.066406 0.160156 C 7.46875 0.160156 8.6875 -0.242188 9.488281 -1.421875 Z M 9.488281 -1.421875 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#141414",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.906467, 20.34611)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.808594 -7.046875 L 1.402344 -7.046875 L 1.402344 -5.386719 L 6.808594 -5.386719 Z M 6.808594 -7.046875 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#141414",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.674456, 20.34611)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.546875 -14.15625 L 1.722656 -14.15625 L 1.722656 0 L 8.046875 0 C 10.730469 0 12.113281 -2.121094 12.113281 -4.222656 C 12.113281 -5.546875 11.53125 -7.027344 9.929688 -7.707031 C 10.890625 -8.429688 11.332031 -9.449219 11.332031 -10.472656 C 11.332031 -12.332031 9.871094 -14.15625 7.546875 -14.15625 Z M 7.507812 -8.429688 L 3.722656 -8.429688 L 3.722656 -12.234375 L 7.546875 -12.234375 C 8.6875 -12.234375 9.230469 -11.332031 9.230469 -10.390625 C 9.230469 -9.429688 8.628906 -8.429688 7.507812 -8.429688 Z M 8.046875 -1.960938 L 3.722656 -1.960938 L 3.722656 -6.425781 L 8.046875 -6.425781 C 9.410156 -6.425781 10.089844 -5.304688 10.089844 -4.203125 C 10.089844 -3.101562 9.410156 -1.960938 8.046875 -1.960938 Z M 8.046875 -1.960938 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#141414",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.526177, 20.34611)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.753906 0 L 12.753906 -10.832031 L 10.792969 -10.832031 L 10.8125 -9.390625 C 9.851562 -10.691406 8.230469 -11.011719 6.886719 -11.011719 C 3.222656 -11.011719 1.101562 -8.390625 1.101562 -5.464844 C 1.101562 -2.484375 3.144531 0.179688 6.925781 0.179688 C 8.269531 0.160156 10.011719 -0.28125 10.792969 -1.460938 L 10.792969 0 Z M 10.792969 -5.425781 C 10.792969 -2.824219 8.6875 -1.5625 6.886719 -1.5625 C 4.484375 -1.5625 3.0625 -3.421875 3.0625 -5.464844 C 3.0625 -7.609375 4.503906 -9.289062 6.886719 -9.289062 C 8.730469 -9.289062 10.792969 -8.007812 10.792969 -5.425781 Z M 10.792969 -5.425781 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#141414",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.578982, 20.34611)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 0 L 3.464844 0 L 3.464844 -14.015625 L 1.5 -14.015625 Z M 1.5 0 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYariga);
export default __webpack_public_path__ + "static/media/yariga.47655e55d84eaa1219d9d4ee71d826f2.svg";
export { ForwardRef as ReactComponent };